import z, { literal } from 'zod';

import { requiresActivationConstraintWithLimitsSchema } from '@occc/feat-constraints/schemas';
import { AwardCountWithTransactionFrequencyOnlySchema } from './award-count.schema';
import {
  AwardNullableVariantSchema,
  AwardPointsVariantSchema,
  AwardVouchersVariantSchema,
} from './award.schema';
import { BaseOfferConfigurationSchema } from './base-offer.schema';
import { OfferType } from '../types';

const ExternalFulfillmentOfferBaseSchema = BaseOfferConfigurationSchema.extend({
  offerType: literal(OfferType.ExternalFulfillment),
  awardCount: AwardCountWithTransactionFrequencyOnlySchema,
  activation: requiresActivationConstraintWithLimitsSchema,
});

export const ExternalFulfillmentOfferSchema = z.discriminatedUnion('awardType', [
  ExternalFulfillmentOfferBaseSchema.merge(AwardNullableVariantSchema),
  ExternalFulfillmentOfferBaseSchema.merge(AwardPointsVariantSchema),
  ExternalFulfillmentOfferBaseSchema.merge(AwardVouchersVariantSchema),
]);
